import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Share from './Share';
import ChristmasParty from './components/ChristmasParty/ChristmasParty';
import OutrTicketDetail from './components/OutrTicketDetail/OutrTicketDetail';
import NatureEventDetail from './components/NatureEventDetail/NatureEventDetail';
import PaymentSuccess from './components/PaymentStatus/PaymentSuccess';
import PaymentDecline from './components/PaymentStatus/PaymentDecline';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Share />} />
      <Route path="/share" element={<Share />} />
      <Route path="/nature-detail/:id" element={<ChristmasParty />} />
      <Route path="/ticket-detail" element={<OutrTicketDetail />} />
      <Route path="/event/:id" element={<NatureEventDetail />} />
      <Route path="/bugreport" element={<BugReportRedirect />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-decline" element={<PaymentDecline />} />
    </Routes>
  );
}

function BugReportRedirect() {
  React.useEffect(() => {
    window.location.href = 'https://docs.google.com/forms/d/e/1FAIpQLScJgDlf-sv6tnDR5Aas8YdstL8ZyiXfaR1GhXzHoIs7b2wwNA/viewform?usp=sharing&ouid=114586538552934200012';
  }, []);
  return <div>Redirecting to bug report form...</div>;
}

export default App;